import * as React from "react";
import { useCallback, useContext } from "react";
import DashboardPageContext from "views/components/contexts/DashboardPageContext";
import ConfirmDeletingDashboardPage from "views/logic/views/ConfirmDeletingDashboardPage";
import useQueryIds from "views/hooks/useQueryIds";
import useQueryTitles from "views/hooks/useQueryTitles";
import useViewMetadata from "views/hooks/useViewMetadata";
import useViewsDispatch from "views/stores/useViewsDispatch";
import { selectQuery, createQuery, removeQuery } from "views/logic/slices/viewSlice";
import useWidgetIds from "views/components/useWidgetIds";
import { setTitle } from "views/logic/slices/titlesActions";
import QueryTabs from "./QueryTabs";
const onRemovePage = async (dashboardId, queryId, activeQueryId, queries, widgetIds, dispatch) => {
  if (queries.size === 1) {
    return Promise.resolve();
  }
  const result = await ConfirmDeletingDashboardPage(dashboardId, activeQueryId, widgetIds);
  if (result === true) {
    dispatch(removeQuery(queryId));
  }
  return Promise.resolve();
};
const QueryBar = () => {
  const queries = useQueryIds();
  const queryTitles = useQueryTitles();
  const { activeQuery: activeQueryId, id: dashboardId } = useViewMetadata();
  const { setDashboardPage } = useContext(DashboardPageContext);
  const widgetIds = useWidgetIds();
  const dispatch = useViewsDispatch();
  const onSelectPage = useCallback(
    (pageId) => {
      if (pageId === "new") {
        dispatch(createQuery()).then((newPageId) => setDashboardPage(newPageId));
      } else {
        setDashboardPage(pageId);
        dispatch(selectQuery(pageId));
      }
    },
    [dispatch, setDashboardPage]
  );
  const removePage = useCallback(
    (queryId) => onRemovePage(dashboardId, queryId, activeQueryId, queries, widgetIds, dispatch),
    [dashboardId, activeQueryId, queries, widgetIds, dispatch]
  );
  const _onTitleChange = useCallback(
    (queryId, newTitle) => dispatch(setTitle(queryId, "tab", "title", newTitle)),
    [dispatch]
  );
  return /* @__PURE__ */ React.createElement(
    QueryTabs,
    {
      queries,
      titles: queryTitles,
      dashboardId,
      onSelect: onSelectPage,
      onTitleChange: _onTitleChange,
      onRemove: removePage
    }
  );
};
export default QueryBar;
